<template>
  <div class="zoom-controls">
    <button
      class="zoom-button zoom-button--zoomin btn--secondary"
      @click="zoom('in')"
    >
      <font-awesome-icon icon="search-plus" />
      <span>{{ $t("buttons.zoom_in") }}</span>
    </button>
    <button
      class="zoom-button zoom-button--zoomout btn--secondary"
      @click="zoom('out')"
    >
      <font-awesome-icon icon="search-minus" />
      <span>{{ $t("buttons.zoom_out") }}</span>
    </button>
    <button
      class="zoom-button zoom-button--refresh btn--secondary"
      @click="resetPosition()"
    >
      <font-awesome-icon icon="arrows-alt" />
      <span>{{ $t("buttons.zoom_reset") }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "zoom-controls",
  methods: {
    zoom(direction) {
      this.$emit("zoom", direction);
    },
    resetPosition() {
      this.$emit("resetPosition");
    },
  },
};
</script>